import { Link } from "react-router-dom";
import { motion as Motion } from "framer-motion";

const MotionLink = Motion.create(Link);

const Button = ({
  children,
  to,
  onClick,
  variant = "primary",
  className = "",
  pill = false,
  fullWidth = false,
  type = "button",
}) => {
  const baseStyles = `inline-flex items-center justify-center font-inter font-semibold tracking-wide transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F4B400]/40 ${
    pill ? "rounded-full" : "rounded-lg"
  } ${fullWidth ? "w-full" : ""}`;

  const variants = {
    primary: "bg-[#F4B400] text-black hover:bg-[#d9a000] px-6 py-3 shadow-soft",

    secondary:
      "bg-[#7D192A] text-white hover:bg-[#651422] px-6 py-3 shadow-soft",

    outline:
      "bg-transparent border-3 border-white text-white hover:bg-white hover:text-[#1A1C25] px-6 py-3",

    ghost: "text-[#7D192A] hover:bg-[#F5F5F5] px-4 py-2.5",

    nav: "nav-text text-white hover:text-[#F4B400] px-4 py-2",

    maroonOutline:
      "bg-transparent border-2 border-[#7D192A] text-[#7D192A] hover:bg-[#7D192A] hover:text-white px-6 py-3",
  };

  const selectedVariant = variants[variant] || variants.primary;
  const combinedClasses = `${baseStyles} ${selectedVariant} ${className}`;

  const motionProps = {
    whileHover: { y: -2, scale: 1.01 },
    whileTap: { scale: 0.98 },
    transition: { type: "spring", stiffness: 300, damping: 22 },
  };

  if (to) {
    return (
      <MotionLink to={to} className={combinedClasses} {...motionProps}>
        {children}
      </MotionLink>
    );
  }

  return (
    <Motion.button
      type={type}
      onClick={onClick}
      className={combinedClasses}
      {...motionProps}
    >
      {children}
    </Motion.button>
  );
};

export default Button;
